import { useDispatch } from '@sloyd/store-base';
import { useParams } from 'react-router-dom';
import { useMount } from 'react-use';
import { $a } from 'shared-base';
import { PagePlayground } from './PagePlayground';

export type PagePlaygroundContainerProps = {};

const verbsMap: Json = {
  generators: 'loadGenerator',
  packs: 'loadAssetPack',
  blank: 'create',
  browse: 'browseIdeas',
};

const entityNameMap: Json = {
  generators: 'generator',
  packs: 'asset pack',
  blank: 'playground',
  browse: 'idea',
};

export function PagePlaygroundContainer(_props: PagePlaygroundContainerProps) {
  const dispatch = useDispatch();
  const { category = '', id } = useParams();

  const entityName = entityNameMap[category];

  useMount(() => {
    const verb = verbsMap[category];
    dispatch($a('PLAYGROUND', verb, id));
  });

  return <PagePlayground entityName={entityName} />;
}

export default PagePlaygroundContainer;
